module.exports = __webpack_public_path__ + "img/szh4.a16766a0.jpg";